
import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import axios from '../../../API/axios'
import NotFound from '../../NotFound'
import moment from 'moment'
import toast from 'react-hot-toast'
import { Modal } from 'react-bootstrap'

import CloseSharpIcon from '@mui/icons-material/CloseSharp';



const RecruiterDetails = () => {
    const { uid } = useParams();
    const sessionId = localStorage.getItem("sessionId");

    const userType = localStorage.getItem('userType');
    const token = localStorage.getItem("token");
    const [jobList, setJobList] = useState([]);
    const [isFollowing, setIsFollowing] = useState(false);
    const [companyId, setCompanyId] = useState("");
    const [showUnfollowModal, setshowUnfollowModal] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const progressRef = useRef();
    const navigate = useNavigate();

    const [targetHeight, setTargetHeight] = useState(0);
    const [toggle, setToggle] = useState({
        key: "",
        status: false,
    });
    const [isShowMobile, setShowMobile] = useState(false);

    const handleToggle = (key) => {
        if (toggle.key === key) {
            setToggle({
                status: false,
            });
        } else {
            setToggle({
                status: true,
                key,
            });
        }
    };

    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };

    useEffect(() => {
        if (progressRef?.current) {
            const offsetHeight = progressRef?.current?.offsetTop;
            setTargetHeight(offsetHeight);
        }
    }, [progressRef]);



    const [compnyData, setCompnyData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    console.log("compnyData", compnyData);



    useEffect(() => {
        getCmpnyDetail();
    }, [uid]);

    const getCmpnyDetail = () => {
        axios
            .get(`/Company/GetProfile?UID=${uid}&CompType=Recruiter`)
            .then((response) => {
                if (response.status === 204) {
                    setCompnyData(null);
                } else {
                    setCompnyData(response.data.responseData);
                }
            })
            .catch((error) => {
                setCompnyData(null); // Treat errors as "not found"
                console.error("Error:", error);
            })
            .finally(() => setIsLoading(false));
    };

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (!compnyData) {
        return (
            <NotFound />

        );
    }

    //************************ Follow Company Start  ************************//

    const FollowCompany = async (id) => {
        console.log("Follow Company ID:", id);

        const data = {
            sessionId: sessionId,
            compUID: id, // Pass the correct ID
        };

        try {
            const response = await axios.post("/CandidateAction/FollowCompany", data);
            console.log("Follow response:", response.data.message);

            setIsFollowing((prev) => ({
                ...prev,
                [id]: true, // Update state for this company
            }));
            getCmpnyDetail();
            toast.success(response.data.message);
        } catch (e) {
            console.error("Follow error:", e.response?.data?.message || e.message);
            toast.error(e.response?.data?.message || "Error while following");
        }
    };

    //************************ Follow Company End  ************************//

    //************************ UnFollow Company Start  ************************//
    const handleCloseModal = () => setshowUnfollowModal(false);
    const handleShow = () => setshowUnfollowModal(true);

    const UnFollow = async (id) => {
        console.log("Unfollow Company ID:", id);

        const data = {
            sessionId: sessionId,
            compUID: id, // Pass the correct ID
        };

        try {
            const response = await axios.post("/CandidateAction/UnfollowCompany", data);
            console.log("Unfollow response:", response.data.message);

            // Update the following state for this specific company
            setIsFollowing((prev) => ({
                ...prev,
                [id]: false, // Update state for this company
            }));
            getCmpnyDetail();
            toast.success(response.data.message);
        } catch (e) {
            console.error("Unfollow error:", e.response?.data?.message || e.message);
            toast.error(e.response?.data?.message || "Error while unfollowing");
        }
    };


    const handleConfirmUnfollow = () => {
        UnFollow(companyId); // Pass the specific company ID
        // UnFollow();
        handleCloseModal()

    }; 

    const handleConfirmUnBlock = (companyId) => {
        UnBlockCompany(companyId); // Pass the specific company ID
        handleCloseModal()

    };
    //************************ UnFollow Company End  ************************//

        const handleShowModal = () => setShowModal(true);
        const handlecloseModal = () => setShowModal(false);
    
        const BlockCompany = async (id) => {
            console.log("block id===>", id);
    
            const data = {
                sessionId: sessionId,
                compUID: id,
            };
            try {
                await axios.post("/CandidateAction/BlockCompany", data)
                    .then((resData) => {
                        console.log("Block Company", resData.data.message);
                        toast.success(resData.data.message);
                        getCmpnyDetail();
                        handlecloseModal()
                    });
            } catch (e) {
                if (e.response && e.response.status === 404) {
                    toast.error(e.response.data.message);
                    handlecloseModal()
    
                } else {
                    toast.error(e.response.data.message);
                }
            }
        };
    
        const handleConfirmBlock = (id) => {
            console.log("block uid", uid);
            BlockCompany(id);
            // setShowModal(false)
        };
    
        const UnBlockCompany = async (id) => {
            console.log("unblock", id);
    
            const data = {
                sessionId: sessionId,
                compUID: id,
            };
            // console.log("session ids", sessionId, Compuid);
    
            try {
                await axios.post("/CandidateAction/UnblockCompany", data)
                    .then((resData) => {
                        console.log("Block Company", resData.data.message);
                        toast.success(resData.data.message);
                        getCmpnyDetail();
                    });
            } catch (e) {
                if (e.response && e.response.status === 404) {
                    toast.error(e.response.data.message);
                } else {
                    toast.error(e.response.data.message);
                }
            }
        };


    return (
        <>
            {/* <section className="single-job-thumb">
            <img
                    src={require("../../../assets/images/khoj-images/singlejob.f19680c90ccac510942d.jpg")} 
                    alt="images"
                />
            </section> */}

            <section className=" fixed-space">
                <div className="tf-container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="wd-job-author2 align-items-center">
                                <div className="content-left">
                                    <div className="thumb">
                                        <img
                                            src={compnyData.logoImage}
                                            alt="logo"
                                            width={"100px"} style={{ borderRadius: "50%", height: "100px" }}

                                        />
                                    </div>
                                    <div className="content">
                                        <Link to="#" className="category">
                                            {compnyData?.tagline}
                                        </Link>
                                        <div className="d-flex align-items-center">
                                            <h6>{compnyData.name}</h6>
                                            <span className="rec-badge-purple ms-2">{compnyData.compType}</span>
                                        </div>


                                        <ul className="job-info">
                                            {compnyData?.cityName === "" ? "" : (
                                                <>
                                                    <li>
                                                        <span className="icon-map-pin me-1"></span>
                                                        <span>{compnyData?.cityName}</span>
                                                    </li>
                                                </>
                                            )}
                                            {compnyData.startedDate === null ? '' : <>
                                                <li>
                                                    <span className="icon-calendar me-1"></span>
                                                    &nbsp;
                                                    {moment.utc(compnyData.startedDate).local().format("DD MMMM YYYY")}
                                                </li>
                                            </>
                                            }
                                        </ul>

                                    </div>
                                </div>
                                <div className="content-right">
                                    <div className="top text-end">

                                    </div>
                                    {compnyData.isBlocked === false ? (
                                            <>
                                    {userType === "Candidate" ? (
                                    // <div className="bottom">
                                        <div className="bottom">
                                            {token === null ? (
                                                ""
                                            ) : compnyData.isFollowed === true ? (
                                                // Unfollow Button
                                                <div className="button-readmore text-end mb-2">
                                                    <button
                                                        className="mainBtn apply-job btn btn-primary"
                                                        onClick={() => {
                                                            handleShow();
                                                            setCompanyId(compnyData.uid)
                                                        }} // Show Unfollow modal
                                                    >
                                                        Unfollow
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="button-readmore  text-end mb-2">
                                                    <button
                                                        className="mainBtn apply-job btn btn-primary"
                                                        onClick={() => FollowCompany(compnyData.uid)} // Follow company
                                                    >
                                                        Follow
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ) :
                                    ""}
                                    </>
                                        ): ""} 

                                      <div>
                                            {userType === "Candidate" ? (
                                                <div className="bottom">
                                                    {token === null ? (
                                                        ""
                                                    ) : compnyData.isBlocked === true ? (
                                                        // Unfollow Button
                                                        <div className="button-readmore text-end">
                                                            <button
                                                                className="mainBtn apply-job btn btn-primary custom-btn w-100"

                                                                // onClick={() => UnBlockCompany(compnyData.uid)} // Follow company
                                                                onClick={() => {
                                                                    handleConfirmUnBlock(compnyData.uid);
                                                                    // setBlockId(compnyData.uid)
                                                                }}
                                                            >
                                                                Unblock
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div className="button-readmore  text-end">
                                                            <button
                                                                className="mainBtn apply-job btn btn-primary w-100"

                                                                onClick={() => handleShowModal()} // Follow company
                                                            >
                                                                Block
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            ) :
                                                ""}
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="container mt-3">
                <section className="inner-jobs-section">
                    <div className="tf-container">
                        <div className="row">
                            <div className="col-lg-8">
                                <Tabs className="job-article tf-tab single-job">
                                    <TabList className="menu-tab p-0">
                                        <Tab className="ct-tab">About</Tab>
                                        <Tab className="ct-tab">Description</Tab>
                                        {/* <Tab className="ct-tab">Job</Tab> */}
                                    </TabList>
                                    <div className="content-tab">
                                        <TabPanel className="inner-content animation-tab">
                                            {compnyData.about === null ? '' : (
                                                <>
                                                    <p className='p-0'>
                                                        {compnyData.about}
                                                    </p>
                                                </>
                                            )}



                                        </TabPanel>
                                        <TabPanel className="inner-content animation-tab">
                                            {compnyData.description === null ? '' : (
                                                <>
                                                    {/* <h5>Full Job Description</h5> */}
                                                    <p className='p-0'>
                                                        {compnyData.description}
                                                    </p>
                                                </>
                                            )}
                                        </TabPanel>
                                    </div>
                                </Tabs>
                            </div>
                            <div className="col-lg-4">
                                <div className="cv-form-details po-sticky job-sg single-stick email-cv-form-details">
                                    {/* <MapSingle marKers={marKers} /> */}
                                    <ul className="list-infor email-list-infor p-2">

                                        {compnyData.website === null ? '' : (
                                            <li className='only-for-email'>
                                                <div className="category">Website</div>
                                                <div className="detail">
                                                    <a
                                                     href={compnyData.website ? compnyData.website.startsWith("http") ? compnyData.website : `https://${compnyData.website}` : "#"}
                                                     onClick={(e) => {
                                                         if (!compnyData.website) {
                                                             e.preventDefault();
                                                             alert("Website is not available!");
                                                         }
                                                     }}
                                                     target="_blank"
                                                     rel="noopener noreferrer"
                                                    //  href={compnyData.website}
                                                    >
                                                        {compnyData.website}
                                                    </a>
                                                </div>
                                            </li>
                                        )}
                                        {compnyData.email === null ? '' : (
                                            <li className='only-for-email'>
                                                <div className="category">Email</div>
                                                <div className="detail">
                                                    <a href={`mailto:${compnyData.email}`}
                                                        onClick={(e) => {
                                                            if (!compnyData.email) {
                                                                e.preventDefault();
                                                                alert("Email is not available!");
                                                            }
                                                        }}
                                                    >
                                                        {compnyData.email}
                                                    </a>
                                                </div>
                                            </li>
                                        )}
                                        {compnyData.contactNo === null ? '' : (
                                            <li className='only-for-email'>
                                                <div className="category">Contact No</div>
                                                <div className="detail">
                                                    {/* {compnyData.contactNo} */}
                                                    <a
                                                        href={`tel:${compnyData.contactNo}`}
                                                        onClick={(e) => {
                                                            if (!compnyData.contactNo) {
                                                                e.preventDefault(); 
                                                                alert("Contact number is not available!");
                                                            }
                                                        }}
                                                    >
                                                        {compnyData.contactNo}
                                                    </a>
                                                </div>
                                            </li>
                                        )}
                                        {compnyData.address === null ? '' : (
                                            <li className='only-for-email'>
                                                <div className="category">Address</div>
                                                <div className="detail">
                                                    {compnyData.address}
                                                </div>
                                            </li>
                                        )}
                                        {compnyData.industry === null ? '' : (
                                            <li className='only-for-email'>
                                                <div className="category">Industry</div>
                                                <div className="detail">
                                                    {compnyData.industry}
                                                </div>
                                            </li>
                                        )}
                                        {compnyData.companyCategory === null ? '' : (
                                            <li className='only-for-email'>
                                                <div className="category">Company Category</div>
                                                <div className="detail">
                                                    {compnyData.companyCategory}
                                                </div>
                                            </li>
                                        )}
                                        {compnyData.companySize === null ? '' : (
                                            <li className='only-for-email'>
                                                <div className="category">Company Size</div>
                                                <div className="detail">
                                                    {compnyData.companySize}
                                                </div>
                                            </li>
                                        )}
                                        {compnyData.compType === null ? '' : (
                                            <li className='only-for-email'>
                                                <div className="category">Company Type</div>
                                                <div className="detail">
                                                    {compnyData.compType}
                                                </div>
                                            </li>
                                        )}

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* ...............Unfollow modal............  */}

            <Modal show={showUnfollowModal} onHide={handleCloseModal} centered>
                <Modal.Header >
                    <Modal.Title> Unfollow</Modal.Title>
                    <CloseSharpIcon className="pointer" onClick={handleCloseModal} />
                </Modal.Header>
                <Modal.Body className="settings">
                    <div className=" mb-3">
                        <p>Are you sure you want to Unfollow Company</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={handleConfirmUnfollow} className="btn btn-danger me-2">Confirm</button>
                    {/* <button onClick={handleClose} className="btn btn-secondary">Cancel</button> */}

                </Modal.Footer>

            </Modal>

            <Modal show={showModal} onHide={handlecloseModal} centered>
                <Modal.Header>
                    <Modal.Title>Confirm Block</Modal.Title>
                    <CloseSharpIcon className="pointer" onClick={handlecloseModal} />
                </Modal.Header>
                <Modal.Body className="settings">
                    <div className=" mb-3">
                        <p>Are you sure you want to block Company</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={() => {
                        handleConfirmBlock(compnyData.uid)
                        // setCompUid()

                    }

                    } className="btn btn-danger me-2">Confirm</button>
                    {/* <button onClick={handleClose} className="btn btn-secondary">Cancel</button> */}

                </Modal.Footer>

            </Modal>
        </>
    )
}

export default RecruiterDetails